"use client";

import { CheckCircle2, Zap, TrendingUp, Settings, Sparkles } from "lucide-react";

export default function Packages() {
  return (
    <section className="py-24 bg-[rgb(var(--bg-base))] relative overflow-hidden" id="pakete">
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-20 left-[10%] w-[500px] h-[500px] rounded-full bg-[#1B3A60]/8 blur-[120px]" />
        <div className="absolute bottom-20 right-[10%] w-[400px] h-[400px] rounded-full bg-[#3C2447]/8 blur-[100px]" />
      </div>

      <div className="container mx-auto px-4 md:px-8 relative z-10">
        <div className="max-w-5xl mx-auto">

          <div className="text-center mb-16">
            <div className="inline-flex items-center gap-2 bg-gradient-to-r from-[#1B3A60]/20 to-[#3C2447]/20 border border-[#1B3A60]/30 rounded-full px-4 py-2 text-sm font-medium text-[#C9B37E] mb-4">
              <Sparkles className="w-4 h-4" />
              Transparente Preise
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-[rgb(var(--text-primary))] mb-4">
              Unsere Pakete
            </h2>
            <p className="text-[rgb(var(--text-muted))]">
              SEO-ENGINE + Custom Code: Ingenieurskunst, hochperformante Infrastruktur und klare Prozesse wie im Konzern.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 mb-8">

            <div className="group card-glow bg-gradient-to-br from-[rgb(var(--bg-surface))] to-[rgb(var(--bg-section))] border border-[#1B3A60]/20 hover:border-[#1B3A60]/40 rounded-2xl p-8 transition-all duration-300 hover:-translate-y-1" data-testid="card-package-foundation">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 rounded-full bg-gradient-to-br from-[#1B3A60]/40 to-[rgb(var(--bg-surface))] border border-[#1B3A60]/40 flex items-center justify-center">
                  <Zap className="w-6 h-6 text-[#4A7AB8]" />
                </div>
                <div>
                  <h3 className="text-xl font-bold text-[rgb(var(--text-primary))]">Foundation</h3>
                  <p className="text-[rgb(var(--text-muted-soft))] text-sm">Stabilität & Betrieb</p>
                </div>
              </div>

              <ul className="space-y-3 mb-8">
                <li className="flex items-start gap-3 text-[rgb(var(--text-muted-strong))]">
                  <CheckCircle2 className="w-5 h-5 text-[#4A7AB8] mt-0.5 flex-shrink-0" />
                  Intelligente Schwachstellenanalyse, damit versteckte Fehler keine Anfragen kosten
                </li>
                <li className="flex items-start gap-3 text-[rgb(var(--text-muted-strong))]">
                  <CheckCircle2 className="w-5 h-5 text-[#4A7AB8] mt-0.5 flex-shrink-0" />
                  Neu programmierter Code, der technische Altlasten eliminiert
                </li>
                <li className="flex items-start gap-3 text-[rgb(var(--text-muted-strong))]">
                  <CheckCircle2 className="w-5 h-5 text-[#4A7AB8] mt-0.5 flex-shrink-0" />
                  Monitoring von Ladezeit, Links und Tracking, damit Ausfälle sofort auffallen
                </li>
                <li className="flex items-start gap-3 text-[rgb(var(--text-muted-strong))]">
                  <CheckCircle2 className="w-5 h-5 text-[#4A7AB8] mt-0.5 flex-shrink-0" />
                  Absicherung gegen Ranking- und Sichtbarkeitsverluste
                </li>
                <li className="flex items-start gap-3 text-[rgb(var(--text-muted-strong))]">
                  <CheckCircle2 className="w-5 h-5 text-[#4A7AB8] mt-0.5 flex-shrink-0" />
                  Betrieb mit DevOps und Cloud-Stack, damit Deployments kein Risiko werden
                </li>
                <li className="flex items-start gap-3 text-[rgb(var(--text-muted-strong))]">
                  <CheckCircle2 className="w-5 h-5 text-[#4A7AB8] mt-0.5 flex-shrink-0" />
                  Skalierung mit Instanzen, Caching und CDN, damit Peaks nicht bremsen
                </li>
              </ul>

              <div className="border-t border-[rgb(var(--text-primary)/0.1)] pt-6">
                <div className="flex items-baseline gap-1 mb-2">
                  <span className="text-4xl font-bold text-[rgb(var(--text-primary))]">249 €</span>
                  <span className="text-[rgb(var(--text-muted-soft))]">/ Monat</span>
                </div>
                <p className="text-[rgb(var(--text-muted-faint))] text-sm">Mindestlaufzeit: 12 Monate</p>
              </div>
            </div>

            <div className="group card-glow relative bg-gradient-to-br from-[#1B3A60]/20 via-[rgb(var(--bg-surface))] to-[#3C2447]/10 border-2 border-[#C9B37E]/40 hover:border-[#C9B37E]/60 rounded-2xl p-8 transition-all duration-300 hover:-translate-y-1 shadow-xl shadow-[#C9B37E]/10" data-testid="card-package-growth">
              <div className="absolute -top-3 right-6 bg-gradient-to-r from-[#C9B37E] to-[#E8D4A8] text-[rgb(var(--text-on-light))] text-xs font-bold px-4 py-1 rounded-full shadow-lg shadow-[#C9B37E]/30">
                Empfohlen
              </div>
              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 rounded-full bg-gradient-to-br from-[#C9B37E]/30 to-[rgb(var(--bg-surface))] border border-[#C9B37E]/40 flex items-center justify-center">
                  <TrendingUp className="w-6 h-6 text-[#C9B37E]" />
                </div>
                <div>
                  <h3 className="text-xl font-bold text-[rgb(var(--text-primary))]">Growth</h3>
                  <p className="text-[rgb(var(--text-muted-strong))] text-sm">Sichtbarkeit & Wachstum</p>
                </div>
              </div>

              <p className="text-[rgb(var(--text-muted))] text-sm mb-4">Alles aus Foundation, zusätzlich:</p>
              <ul className="space-y-3 mb-8">
                <li className="flex items-start gap-3 text-[rgb(var(--text-muted-strong))]">
                  <CheckCircle2 className="w-5 h-5 text-[#C9B37E] mt-0.5 flex-shrink-0" />
                  Gezielte Erweiterung um Seiten, die Streuverluste vermeiden und lokale Hochwert-Leads fokussieren
                </li>
                <li className="flex items-start gap-3 text-[rgb(var(--text-muted-strong))]">
                  <CheckCircle2 className="w-5 h-5 text-[#C9B37E] mt-0.5 flex-shrink-0" />
                  Laufende Ausrichtung auf echte Suchanfragen, damit Inhalte nicht am Bedarf vorbeigehen
                </li>
                <li className="flex items-start gap-3 text-[rgb(var(--text-muted-strong))]">
                  <CheckCircle2 className="w-5 h-5 text-[#C9B37E] mt-0.5 flex-shrink-0" />
                  Laufende Auswertung der Sichtbarkeit, damit Ranking-Risiken früh erkannt werden
                </li>
                <li className="flex items-start gap-3 text-[rgb(var(--text-muted-strong))]">
                  <CheckCircle2 className="w-5 h-5 text-[#C9B37E] mt-0.5 flex-shrink-0" />
                  Klare Nutzerführung und Tests, damit Interessenten nicht abspringen
                </li>
              </ul>

              <div className="border-t border-[#C9B37E]/20 pt-6">
                <div className="flex items-baseline gap-1 mb-2">
                  <span className="text-4xl font-bold text-gradient-champagne">449 €</span>
                  <span className="text-[rgb(var(--text-muted-strong))]">/ Monat</span>
                </div>
                <p className="text-[rgb(var(--text-muted-soft))] text-sm">Monatlich kündbar nach 3 Monaten</p>
              </div>
            </div>
          </div>

          <div className="group card-glow bg-gradient-to-br from-[rgb(var(--bg-surface))] to-[rgb(var(--bg-section))] border border-[#3C2447]/30 hover:border-[#3C2447]/50 rounded-2xl p-8 transition-all duration-300" data-testid="card-package-automation">
            <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6">
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 rounded-full bg-gradient-to-br from-[#3C2447]/40 to-[rgb(var(--bg-surface))] border border-[#3C2447]/40 flex items-center justify-center">
                  <Settings className="w-6 h-6 text-[#7A5A8A]" />
                </div>
                <div>
                  <h3 className="text-xl font-bold text-[rgb(var(--text-primary))]">Optional: Automatisierung & Anbindungen</h3>
              <p className="text-[rgb(var(--text-muted))] text-sm">Automatisierung, SEO-Tools und Datenpipelines direkt ins CRM – damit Prozesse nicht an manuellen Fehlern hängen</p>
                </div>
              </div>
              <div className="text-right">
                <div className="flex items-baseline gap-1 justify-end md:justify-start">
                  <span className="text-3xl font-bold text-[rgb(var(--text-primary))]">99 €</span>
                  <span className="text-[rgb(var(--text-muted-soft))]">/ Monat</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
